import { CoralRequest, } from './coral-request';
/**
 * Framework-agnostic abstract Coral service client. Service-specific clients
 * will be generated as concrete subclasses.
 *
 * The structure of this client is heavily influenced by the Angular HttpClient,
 * while remaining framework-agnostic.
 *
 * The handler is responsible for consuming requests and producing responses.
 * When supporting interceptors, this will be an instance of
 * InterceptingRequestHandler -- see CoralClientFactory for an example.
 *
 * (see https://angular.io/guide/http#intercepting-requests-and-responses for
 * more general info on interceptors)
 */
export class CoralClient {
    constructor(config, handler) {
        this.config = config;
        this.handler = handler;
    }
    /**
     * Make a Coral service request.
     */
    call(operation, data) {
        const { assembly, serviceName } = this.constructor;
        const headers = this.constructHeaders(assembly, serviceName, operation);
        return this.handler.handle(new CoralRequest({
            body: data,
            config: this.config,
            headers,
            operation,
            serviceName,
            url: this.config.httpEndpoint.url,
        }));
    }
    constructHeaders(assembly, serviceName, operation) {
        return [
            ['Content-Encoding', 'amz-1.0'],
            ['Content-Type', 'application/json;charset=UTF-8'],
            ['X-Amz-Target', `${assembly}.${serviceName}.${operation}`],
        ];
    }
}
